import { render, staticRenderFns } from "./TabConfrontiOre.vue?vue&type=template&id=6e569df1&"
import script from "./TabConfrontiOre.vue?vue&type=script&lang=js&"
export * from "./TabConfrontiOre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports